import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SelectBox, TimeApiService } from 'cbc-shared-lib';
import { cloneDeep } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  ResponseCommon,
  Sgke011aRequest,
  Sgke011aResponseInitialhyojiInfo,
  Sgke012aRequest,
  Sgke012aResponse,
  Sgke012aResponseSearchResultList,
  Szza012aRequest,
} from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgke012aService } from '../../services/used-sgke012a.service';
import { UsedSzza012aService } from '../../../../../sg-ke-shared/services/used-szza012a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';
import { UsedSgke011aService } from '../../services/used-sgke011a.service';

@Component({
  selector: 'app-sgke010d',
  templateUrl: './sgke010d.component.html',
  styleUrl: './sgke010d.component.scss',
})
/**
 *
 * 未精算整理照会
 * @export
 * @class Sgke010dComponent
 */
export class Sgke010dComponent implements OnInit, OnDestroy {
  /**  エラーメッセージリスト */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  errorInfoEmitter = new EventEmitter<string>();
  // 検索情報レスポンス
  response: Sgke012aResponse;
  //リクエスト共通エリア
  responseCommon: ResponseCommon;
  // 検索結果情報
  searchResultList: Array<Sgke012aResponseSearchResultList>;
  //入金取扱機関
  bankList: SelectBox[];
  // 未精算整理照会検索リクエストデータ
  sgke012arequestData: UntypedFormGroup;
  // 検索情報
  initIndicateConditionInfo: UntypedFormGroup;
  /** 業務日付 */
  businessDate: Date;
  /** 業務日付取得APIリクエスト */
  requestSzza012a: Szza012aRequest;
  /** SGKE011A_未精算整理照会初期表示APIリクエスト */
  requestSgke011a: Sgke011aRequest;
  /** ダブルクリック押下フラグ */
  dblClickFlg: boolean = false;
  /** 初期表示データ */
  initialhyojiInfo: Sgke011aResponseInitialhyojiInfo;

  /**
   * コンストラクタ
   * @param {UsedSgke012aService} searchService
   * @param {UntypedFormBuilder} fb
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke010dComponent
   */
  constructor(
    public searchService: UsedSgke012aService,
    public initSgke011aService: UsedSgke011aService,
    public initService: UsedSzza012aService,
    private timeApiService: TimeApiService,
    private cd: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    public responseMsgUtils: ResponseMsgUtils
  ) { }
  /** コンポーネント破棄処理*/
  private onDestroy$ = new Subject();

  /**
   * コンポーネント初期化時処理
   * @memberof Sgke010dComponent
   */
  ngOnInit() {
    this.searchService.searchedValueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((response) => {
        this.response = response;
        this.searchResultList = response.shtkInfo?.searchresultList;
        this.responseCommon = response.responseCommon;
      });

    // リクエスト情報をもつオブジェクトを定義
    this.requestSzza012a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      businessDayKbn: null,
    };

    // SZZA012A呼び出し
    this.initService
      .doSzza012a(this.requestSzza012a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (response) => {
          if (response?.todayDay) {
            this.businessDate = this.timeApiService.convertStringToDate(
              response.todayDay
            );
          }

          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(
            response?.responseCommon?.errors,
            this.errorMessageModelArray
          );
        },
        (error) => {}
      );
    // sgke011aのリクエスト情報を設定
    this.requestSgke011a = {
      requestCommon: null,
    };

    //SGKE011A呼出し
    this.initSgke011aService
      .doSgke011a(this.requestSgke011a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((response) => {
        this.initialhyojiInfo = response?.initialhyojiInfo;
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(
          response?.responseCommon?.errors,
          this.errorMessageModelArray
        );
      },
      (error) => {}
    );

    // 未精算整理照会検索APIのFormを初期化
    this.sgke012arequestData = this.fb.group({
      requestCommon: new UntypedFormGroup({}),
    });
    this.cd.detectChanges();
  }

  /**
   * 終了処理
   * @memberof Sgke010dComponent
   */
  ngOnDestroy(): void {
    if (!this.dblClickFlg) {
      this.searchService.searchFormValue = null;
    }
    this.searchService.searched = false;

    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 未精算整理照会検索処理
   * @memberof Sgke010dComponent
   */
  search() {
    this.clearErrorMsg();

    this.searchService.searched = false;
    //画面から検索キーを取得し、リクエストに反映。
    let request = this.sgke012arequestData.getRawValue() as Sgke012aRequest;
    this.searchService.searchFormValue = cloneDeep(request);
    //検索処理実施
    this.searchService.doSgke012a(request).subscribe(
      (response) => {
        this.searchResultList = response?.shtkInfo?.searchresultList;
        this.searchService.searched = true;
        // メッセージを表示
        this.errorMessageModelArray = Array.from(this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray));
      },
      (error) => {
      }
    );
  }
  /**
   * クリア処理
   * @memberof Sgke010dComponent
   */
  clear() {
    this.clearErrorMsg();
    this.searchService.searched = false;
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke010dComponent
   */
  private clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

  /**
   * ダブルクリック押下フラグをセット
   * @memberof Sgke010dComponent
   */
  dblClickFlgSet() {
    this.dblClickFlg = true;
  }

}
